import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './authApi';

export const returnApi = createApi({
  reducerPath: 'returnApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['OrderReturn', 'ReturnReasonCode'],
  endpoints: (builder) => ({

    // GET /api/v1/pos/orders/:orderId/returns
    listOrderReturns: builder.query({
      query: ({ orderId, page = 1, per_page = 50 } = {}) => ({
        url: `/orders/${orderId}/returns`,
        params: { page, per_page },
      }),
      providesTags: (result, error, { orderId }) => [{ type: 'OrderReturn', id: `ORDER_${orderId}` }],
    }),

    // GET /api/v1/pos/order_returns (store-wide)
    listStoreReturns: builder.query({
      query: ({ status, date_from, date_to, page = 1, per_page = 25 } = {}) => ({
        url: '/order_returns',
        params: { status, date_from, date_to, page, per_page },
      }),
      providesTags: [{ type: 'OrderReturn', id: 'STORE_LIST' }],
    }),

    // GET /api/v1/pos/orders/:orderId/returns/:id
    getOrderReturn: builder.query({
      query: ({ orderId, id }) => `/orders/${orderId}/returns/${id}`,
      providesTags: (result, error, { id }) => [{ type: 'OrderReturn', id }],
    }),

    // GET /api/v1/pos/return_reason_codes
    getReturnReasonCodes: builder.query({
      query: () => '/return_reason_codes',
      providesTags: [{ type: 'ReturnReasonCode', id: 'LIST' }],
    }),

    // POST /api/v1/pos/orders/:orderId/returns  → draft
    createReturn: builder.mutation({
      query: ({ orderId, refund_method, notes, items }) => ({
        url: `/orders/${orderId}/returns`,
        method: 'POST',
        body: {
          order_return: {
            ...(refund_method ? { refund_method } : {}),
            ...(notes ? { notes } : {}),
            order_return_items_attributes: items,
          },
        },
      }),
    }),

    // POST /api/v1/pos/orders/:orderId/returns/:id/complete
    completeReturn: builder.mutation({
      query: ({ orderId, id }) => ({
        url: `/orders/${orderId}/returns/${id}/complete`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, { orderId }) => [
        { type: 'OrderReturn', id: `ORDER_${orderId}` },
        { type: 'OrderReturn', id: 'STORE_LIST' },
      ],
    }),

    // GET /api/v1/pos/orders/:orderId/returns/:id/credit_note  → PDF blob
    getCreditNote: builder.query({
      query: ({ orderId, id }) => ({
        url: `/orders/${orderId}/returns/${id}/credit_note`,
        responseHandler: (response) => response.blob(),
      }),
    }),

  }),
});

export const {
  useListOrderReturnsQuery,
  useLazyListOrderReturnsQuery,
  useListStoreReturnsQuery,
  useGetOrderReturnQuery,
  useLazyGetOrderReturnQuery,
  useGetReturnReasonCodesQuery,
  useCreateReturnMutation,
  useCompleteReturnMutation,
  useLazyGetCreditNoteQuery,
} = returnApi;
